import React, { useState, useEffect } from "react";

const WordAnimation = () => {
  const [displayedText, setDisplayedText] = useState("This is ");
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentLetterIndex, setCurrentLetterIndex] = useState(0);
  const [isReversing, setIsReversing] = useState(false);

  const words = [

    "User Friendly",
    " Convenient",
    "Affordable",
    "Transparent",
    "Interactive",
    "Productivity ",
    "Accountability"
  ]; // Add more words as needed
  const wordDelay = 1000; // Delay before the next word starts after the current one disappears
  const letterDelay = 150; // Delay between each letter

  useEffect(() => {
    const currentWord = words[currentWordIndex];

    if (isReversing) {
      // Remove a letter
      if (currentLetterIndex > 0) {
        const timeout = setTimeout(() => {
          setDisplayedText(
            "This is " + currentWord.slice(0, currentLetterIndex - 1)
          );
          setCurrentLetterIndex((prev) => prev - 1);
        }, letterDelay);
        return () => clearTimeout(timeout);
      } else {
        // Move to the next word
        setIsReversing(false);
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      }
    } else {
      // Add a letter
      if (currentLetterIndex < currentWord.length) {
        const timeout = setTimeout(() => {
          setDisplayedText(
            "This is " + currentWord.slice(0, currentLetterIndex + 1)
          );
          setCurrentLetterIndex((prev) => prev + 1);
        }, letterDelay);
        return () => clearTimeout(timeout);
      } else {
        // Start reversing after a delay
        const timeout = setTimeout(() => {
          setIsReversing(true);
        }, wordDelay);
        return () => clearTimeout(timeout);
      }
    }
  }, [currentLetterIndex, isReversing, currentWordIndex, words]);

  return (
    <a style={{ fontSize: "18px" }}>
      {displayedText}
    </a>
  );
};

export default WordAnimation;
